import { fulfilled, pending, rejected } from '../../../utils';
import { LOAN } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const loanReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(LOAN):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(LOAN):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(LOAN):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default loanReducer;
